import "./Home.module.css";
import NavigationPortal from "@/reusable_sections/Header";
import InterstellarGateway from "./sections/InterstellarGateway";
import BusinessUnits from "./sections/BusinessUnits";
import EngineeringAdvantages from "./sections/EngineeringAdvantages";
import GlobalInfrastructureMap from "./sections/GlobalInfrastructureMap";
import InnovationInsights from "./sections/InnovationInsights";
import VerifiedSupplierTrustBadges from "./sections/VerifiedSupplierTrustBadges";
import ClientTrust from "./sections/ClientTrust";
import ConsultWithOurExperts from "./sections/ConsultWithOurExperts";
import CoreBusinessAreas from "./sections/CoreBusinessAreas";
import Partners from "./sections/Partners";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <NavigationPortal />
      <InterstellarGateway />
      <BusinessUnits />
      <CoreBusinessAreas />
      <Partners />
      <EngineeringAdvantages />
      <GlobalInfrastructureMap />
      <InnovationInsights />
      <VerifiedSupplierTrustBadges />
      <ClientTrust />
      <ConsultWithOurExperts />
      <Footer />
    </div>;
}